import React from 'react';
import ReactDOM from 'react-dom';
//Root Page
import App from './App';
//CSS
import 'bootstrap/dist/css/bootstrap.min.css';
//
ReactDOM.render(
  <App />,
  document.getElementById('root')
);